import { Search } from 'lucide-react';
import { AutoComplete, type AutoCompleteProps } from './AutoComplete';

interface SearchAutocompleteProps<T> extends Omit<AutoCompleteProps<T>, 'value' | 'onChange'> {
  search: string;
  setSearch: (search: string) => void;
  placeholder?: string;
}

export function SearchAutoComplete<T>(props: SearchAutocompleteProps<T>) {
  const { search, setSearch, ...rest } = props;
  return (
    <AutoComplete
      value={search}
      onChange={setSearch}
      icon={<Search className="text-gray-500" />}
      {...rest}
    />
  );
}
